module.exports = {"name":"Detail schvalovacieho dokumentu","icon":"<i class='material-icons'>chrome_reader_mode</i>","widget":[{"type":"user-task-detail","schemas":{"organizations-base":"urn:mbry:schema:1:organizations-base:v1","persons-base":"urn:mbry:schema:1:persons-base:v1","registration-form-base":"urn:mbry:schema:1:registration-form-base:v1"},"initData":{},"api":{"url":"usertasks/detail","id":"usertaskId"}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/user-task-detail/user-task-detail.json
// module id = 401
// module chunks = 0